import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faArrowsAlt } from '@fortawesome/free-solid-svg-icons/faArrowsAlt'
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons/faUndoAlt'
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons/faSyncAlt'
import { faCopy } from '@fortawesome/free-regular-svg-icons/faCopy'
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit'
import { faSave } from '@fortawesome/free-regular-svg-icons/faSave'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus'
import { faSort } from '@fortawesome/free-solid-svg-icons/faSort'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faExpand } from '@fortawesome/free-solid-svg-icons/faExpand'
import { faDotCircle } from '@fortawesome/free-regular-svg-icons/faDotCircle'
import { faImage } from '@fortawesome/free-regular-svg-icons/faImage'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'

Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(
  faTimes,
  faArrowsAlt,
  faUndoAlt,
  faSyncAlt,
  faCopy,
  faTrash,
  faEdit,
  faSave,
  faPlus,
  faMinus,
  faSort,
  faCheck,
  faExpand,
  faDotCircle,
  faImage,
  faChevronRight
)
